var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/trash"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 17.75c-.15 0-.25-.05-.35-.15L7.4 9.1c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l8.5 8.5c.2.2.2.5 0 .7-.1.1-.2.15-.35.15z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.5h-13s-2 0-2 2.5v1h17V5c0-2.5-2-2.5-2-2.5z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 3h-3.85c-.25-1.15-1.25-2-2.45-2-1.2 0-2.2.85-2.45 2H5.2C3.4 3 2 4.45 2 6.2v1.3h1.55l.75 11.3c.1 1.8 1.65 3.2 3.55 3.2h7.25c1.9 0 3.45-1.4 3.55-3.2l.8-11.3H21V6.2C21 4.45 19.55 3 17.8 3zm-6.3-1c.65 0 1.2.4 1.4 1h-2.8c.2-.6.75-1 1.4-1zm6.2 16.75C17.6 20 16.5 21 15.15 21h-7.3c-1.35 0-2.5-1-2.55-2.25L4.55 7.5h13.9l-.75 11.25zM20 6.5H3v-.3C3 5 4 4 5.2 4h12.6C19 4 20 5 20 6.2v.3zM6.9 17.4l3.9-3.9-3.9-3.9c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l3.9 3.9 3.9-3.9c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-3.9 3.9 3.9 3.9c.2.2.2.5 0 .7-.1.1-.25.15-.35.15a.54.54 0 0 1-.35-.15l-3.9-3.9-3.9 3.9c-.1.1-.25.15-.35.15a.54.54 0 0 1-.35-.15c-.2-.2-.2-.5 0-.7z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.75f37a848215d4d390c15e9ad7791e91.svg";
export { ForwardRef as ReactComponent };